import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconText1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconText1"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V7H19V5H13V19H15V21H9V19H11V5H5V7H3V3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconText1;
